// not really an enum, a lookup to convert AppliedProductIds to user readable names
export var AppliedProduct;
(function (AppliedProduct) {
    AppliedProduct["csr24"] = "CSR24";
    AppliedProduct["ezl"] = "EZLynx";
    AppliedProduct["epic"] = "Epic";
    AppliedProduct["mob"] = "Mobile";
    AppliedProduct["standalone"] = "Standalone";
})(AppliedProduct || (AppliedProduct = {}));
//# sourceMappingURL=AppliedProduct.js.map